import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityNotifyApi } from 'api';

import { bankAccountQuery } from '../containers/Branding/Farm/Setting/commons/query';

export const createEntityNotify = createAsyncThunk(
  'entityNotify/createEntityNotify',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityNotifyZalo = createAsyncThunk(
  'entityNotify/createEntityNotifyZalo',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.createNotificationZalo(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityNotify = createAsyncThunk(
  'entityNotify/findEntityNotify',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityNotify = createAsyncThunk(
  'entityNotify/filterEntityNotify',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityNotificationZalo = createAsyncThunk(
  'entityNotify/findEntityNotificationZalo',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.findNotificationZalo(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityForSetting = createAsyncThunk(
  'entityNotify/findEntityForSetting',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.findEntityForSetting(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityNotifyById = createAsyncThunk(
  'entityNotify/findEnityNotifyById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityNotificationZaloById = createAsyncThunk(
  'entityNotify/findEntityNotificationZaloById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.findOneEntityNotificationZalo(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityNotify = createAsyncThunk(
  'entityNotify/updateEntityNotify',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityNotifyApi.update(id, params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityNotifyZalo = createAsyncThunk(
  'entityNotify/updateEntityNotifyZalo',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.updateNotificationZalo(
        option.id,
        option.body
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityNotify = createAsyncThunk(
  'entityNotify/deleteEntityNotify',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityNotifyApi.delete(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  query: any;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
  query: bankAccountQuery,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const entityNotifySlice = createSlice({
  name: 'entityNotify',
  initialState,
  reducers: {
    reloadEntityNotify(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationNotify(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListNotify(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(findEntityNotify.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.tableList = data;
    });
  },
});

const { actions, reducer: entityNotifyReducer } = entityNotifySlice;

export const { updateSavedPaginationNotify, updateSavedListNotify } = actions;
export default entityNotifyReducer;
